import { render, staticRenderFns } from "./GroupForumAnswers.vue?vue&type=template&id=877712d0&"
import script from "./GroupForumAnswers.vue?vue&type=script&lang=js&"
export * from "./GroupForumAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports